var header = document.querySelector(".header");
var scrollPos = 0;

window.addEventListener("scroll", function() {
	if (!header.classList.contains("open") && window.pageYOffset >= 0) {
		if (document.body.getBoundingClientRect().top >= scrollPos) {
			header.classList.remove("animation");
			header.classList.add("sticky");
		} else {
			header.classList.add("animation");
			header.classList.remove("sticky");
		}

		if (window.scrollY == 0) {
			header.classList.remove("sticky");
		}

		scrollPos = document.body.getBoundingClientRect().top;
	}
});



// WEBPACK FOOTER //
// ./scripts/modules/_sticky-header.js